<template>
  <section>
    <ChooseTmpl
      ref="chooseTmpl"
      title="选择订单"
      :resultVal="resultVal"
      :isRadio="isRadio"
      :otherSearchData="otherSearchData"
      :searchBoxDataTmpl="customSearchboxData.form ? customSearchboxData : searchBoxDataTmpl"
      :getListApi="getListApi"
      :tableTitle="tableTitle"
      :tableSelectTar="tableSelectTar"
      :showTableTitle="showTableTitle"
      :handleSearchData="handleSearchData"
      @change="handleResultChange"
      @show="show"
      :customShow="customShow"
      :showName="showName"
      :disabled="disabled"
      :placeholder="placeholder"
      :clearable="clearable"
    >
      <section slot="tableSlot" slot-scope="scope">
        <section v-if="scope.column.property === 'certificatesInsuranceFee'">
          <span>{{ scope.row[scope.column.property] / 100 }}</span>
        </section>
        <section v-else>{{ scope.row[scope.column.property] }}</section>
      </section>
    </ChooseTmpl>
  </section>
</template>

<script>
import {
  orderListDialog,
} from 'api/operate';
import ChooseTmpl from 'components/choose/tmpl/tmpl.vue';
export default {
  components: {
    ChooseTmpl,
  },
  model: {
    prop: 'resultVal', // 父级传进来的值
    event: 'change',
  },
  props: {
    clearable: { // 清除按钮
      type: Boolean,
      default: false,
    },
    resultVal: {
      default: '',
    },
    isRadio: {
      type: Boolean,
      default: false,
    },
    disabled: { // 禁用状态
      type: Boolean,
      default: false,
    },
    otherSearchData: {
      type: Object,
      default: () => ({}),
    },
    placeholder: {
      default: '请选择',
    },
    customShow: { // 是否自定义展示结果
      type: Boolean,
      default: false,
    },
    customSearchboxData: { // 自定义搜索条件
      type: Object,
      default: () => ({}),
    },
    handleParamsData: {
      type: Function,
    },
  },
  data () {
    return {
      showName: 'orderId',
      tableSelectTar: 'orderId',
      searchBoxDataTmpl: {
        form: [
          { // 司机姓名
            label: '司机姓名',
            value: 'carDriverMan',
            type: 'input',
            placeholder: '请输入司机姓名',
            width: '240px',
            disabled: false,
          },
          { // 手机号码
            label: '手机号码',
            value: 'carDriverPhone',
            type: 'input',
            placeholder: '请输入手机号码',
            width: '240px',
          },
          { // 订单号
            label: '订单号',
            value: 'orderId',
            type: 'input',
            placeholder: '请输入订单号',
            width: '240px',
          },
          { // 车牌号码
            label: '车牌号码',
            value: 'plateNumber',
            type: 'input',
            placeholder: '请输入车牌号码',
            width: '240px',
            disabled: false,
          },
          { // 订单类型
            label: '订单类型',
            value: 'isHis',
            type: 'select',
            placeholder: '请选择订单类型',
            default: -1,
            options: [
              {
                label: '在途',
                value: -1,
              },
              {
                label: '历史',
                value: 1,
              },
            ],
            width: '240px',
          },
        ],
      },
      showTableTitle: [
        {
          prop: 'plateNumber',
          label: '车牌号码',
        },
        {
          prop: 'licenceTypeName',
          label: '证照类型',
        },
      ],
      tableTitle: [
        {
          prop: 'orderId',
          label: '订单号',
        },
        {
          prop: 'carDriverMan',
          label: '司机姓名',
        },
        {
          prop: 'carDriverPhone',
          label: '司机手机',
        },
        {
          prop: 'plateNumber',
          label: '车牌号码',
        },
        {
          prop: 'sourceRegionName',
          label: '出发地点',
        },
        {
          prop: 'desRegionName',
          label: '到达地点',
        },
      ],
    };
  },
  methods: {
    getListApi: orderListDialog,
    handleResultChange (val) {
      this.$emit('change', val);
    },
    handleSearchData (searchBoxData) {
      this.handleParamsData && this.handleParamsData(searchBoxData);
      return searchBoxData;
    },
    setOrderFormAttrVal (attr, value, names) {
      this.setFormAttrVal({
        form: this.searchBoxDataTmpl,
        attr,
        value,
        names,
      });
    },
    show () {
      this.setOrderFormAttrVal('disabled', false);
      this.$emit('show');
    },
  },
};
</script>

<style>
</style>
